module.exports = __webpack_public_path__ + "img/icon-teacherTrain-5.9829ca45.png";